import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginFormExpress from './pages/LoginForm/Express/LogInExpress';
import SigninExpress from './pages/LoginForm/Express/SignInExpress';
import PasswordRecoveryExpress from './pages/LoginForm/Express/PasswordRecovery';
import PruffConnectLayout from './layouts/PruffConnect';
import ConfirmUserRegistration from './pages/PublicLandings/ConfirmUseRegistration';
import SGRValidator from './pages/PublicLandings/SGRValidator';

const PruffConnectOpenRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <PruffConnectLayout>
              <LoginFormExpress />
            </PruffConnectLayout>
          }
        />
        <Route
          path="/confirmRegistration/:code"
          element={
            <PruffConnectLayout>
              <ConfirmUserRegistration />
            </PruffConnectLayout>
          }
        />
        <Route
          path="/sign-in"
          element={
            <PruffConnectLayout>
              <SigninExpress />
            </PruffConnectLayout>
          }
        />
        <Route
          path="/password-recovery"
          element={
            <PruffConnectLayout>
              <PasswordRecoveryExpress />
            </PruffConnectLayout>
          }
        />
        <Route path="/sgr-validator" element={<SGRValidator />} />
        <Route
          path="/*"
          element={
            <PruffConnectLayout>
              <LoginFormExpress />
            </PruffConnectLayout>
          }
        />
      </Routes>
    </Router>
  );
};

export default PruffConnectOpenRoutes;
